export default {
  One: 1,
  OneThousand: 1000,
  OneMillion: 1000000,
  OneBillion: 1000000000,
};
